import React, { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Heading from "../../Shared/Common/Heading";
import SimpleImage from "../../Shared/Media/SimpleImage";
import VisionImg from "../../../assets/images/vision.webp";
import { FormattedMessage } from "react-intl";
import { AnchorButton } from "../../Shared/Common/Anchor/Button";

const Vision: FC = () => {
  return (
    <div className="vision-area">
      <Container>
        <Heading type="section-heading">
          <FormattedMessage id="page.about.vision.title" />
        </Heading>
        <Row>
          <Col sm={12} md={12} lg={6}>
            <SimpleImage src={VisionImg} />
          </Col>
          <Col sm={12} md={12} lg={6} className="vision-description">
            <p>
              <FormattedMessage
                id={"page.about.vision.description"}
                values={{ br: <br /> }}
              />
            </p>
            <div className="d-flex">
              <AnchorButton
                href="https://www.nissan-global.com/EN/COMPANY/PLAN/VISION/"
                href_jp="https://www.nissan-global.com/JP/COMPANY/PLAN/VISION/"
                external={true}
                variant={"primary-outline"}
              >
                <FormattedMessage id={"page.common.learn_more"} />
              </AnchorButton>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default Vision;
